import {Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {AuthService} from 'src/app/service/autenticacao/auth.service';
import {SelectOptionModel} from "../../../../../componentes/carbon/carbon-select-option/model/SelectOptionModel";
import {CheckOptionModel} from "../../../../../componentes/carbon/carbon-checkbox-group/model/CheckOptionModel";
import {NumeroProcessoPipe} from "../../../../../pipe/numero-processo.pipe";

@Component({
  selector: 'infancia-juventude',
  templateUrl: './infancia-juventude.component.html',
  styleUrls: ['./infancia-juventude.component.css'],
  providers: [NumeroProcessoPipe]
})
export class InfanciaJuventudeComponent implements OnInit, OnDestroy {

  @Input() formGroup: FormGroup;
  @Input() readonly: boolean = false;
  opcoesProcessoJudicial = [];

  comarcas: SelectOptionModel[] = [];

  demandaTipos: CheckOptionModel[] = [
    {val: 1, label: 'Unidade de Acolhimento', tooltip: null},
    {val: 2, label: 'Setor Técnico', tooltip: 'Setor técnico é referente a Assistente Social ou Psicólogo.'},
    {val: 3, label: 'Agente Voluntário de Proteção', tooltip: null},
    {val: 4, label: 'Comissariado', tooltip: null},
    {val: 5, label: 'Discriminação contra famílias homoafetivas e transafetivas', tooltip: null}
  ];


  constructor(public authService: AuthService, private numeroProcessoPipe: NumeroProcessoPipe) {
  }

  ngOnInit() {
    this.opcoesProcessoJudicial = [
      {val: 'true', label: 'Sim'},
      {val: 'false', label: 'Não'}
    ];

    if (this.formGroup.get('listaComarcas')) {
      this.comarcas = this.formGroup.get('listaComarcas').value.map(comarca => ({
        value: comarca.codigo,
        nome: comarca.nome
      }));
    }

    this.aplicarValidatorsInfancia();
    this.observarNumeroProcesso();
    this.observarDemandasObrigatoriedade();
    this.normalizarTipoDetalhe();
  }

  ngOnDestroy(): void {
    this.removerValidatorsInfancia();
  }

  normalizarTipoDetalhe(){
    let dados = this.formGroup.get('infancia');
    if (!dados || !dados.value || !dados.value.demandas || !Array.isArray(dados.value.demandas)) {
      return;
    }

    const demandas = [];

    for (let i = 0; i < dados.value.demandas.length; i++) {
      const item = dados.value.demandas[i];
      if (item && item.tipoDetalhe) {
        demandas.push(item.tipoDetalhe.id);
      } else {
        demandas.push(item);
      }
    }
    this.formGroup.patchValue({
      infancia: {
        indProcessoJudicial: dados.value.indProcessoJudicial != null ? String(dados.value.indProcessoJudicial) : null,
        demandas: demandas
      }
    }, { emitEvent: false });
  }

  observarNumeroProcesso(): void {
    const control = this.formGroup.get('infancia.numeroProcessoJudicial');
    control.valueChanges.subscribe(value => {
      if (value) {
        const formatado = this.numeroProcessoPipe.transform(value.replace(/\D/g, ''));
        if (formatado !== value) {
          control.setValue(formatado, {emitEvent: false});
        }
      }
    });
  }

  observarDemandasObrigatoriedade(): void {
    const demandasControl = this.formGroup.get('infancia.demandas');
    const unidadeControl = this.formGroup.get('infancia.nomeUnidadeAcolhimento');

    demandasControl.valueChanges.subscribe((valores: any[]) => {
      const selecionado = valores || [];
      const contemUnidadeAcolhimento =
        Array.isArray(selecionado) && selecionado.includes(1);

      if (contemUnidadeAcolhimento) {
        unidadeControl.setValidators([Validators.required]);
      } else {
        unidadeControl.clearValidators();
      }
      unidadeControl.updateValueAndValidity({ emitEvent: false });
    });
  }

  showNumeroProcesso(): boolean {
    return this.formGroup.get('infancia').get('indProcessoJudicial').value === 'true';
  }

  isUnidadeAcolhimentoSelected(): boolean {
    const tipos = this.formGroup.get('infancia').get('demandas').value || [];
    return tipos.includes(1);
  }

  private aplicarValidators(control: AbstractControl, validators: ValidatorFn[]): void {
    control.setValidators(validators);
    control.updateValueAndValidity({ emitEvent: false });
  }

  private removerValidators(control: AbstractControl): void {
    control.clearValidators();
    control.updateValueAndValidity({ emitEvent: false });
  }

  private aplicarValidatorsInfancia(): void {
    const infanciaGroup = this.formGroup.get('infancia');
    if (infanciaGroup) {
      this.aplicarValidators(infanciaGroup.get('idComarca'), [Validators.required]);
      this.aplicarValidators(infanciaGroup.get('indProcessoJudicial'), [Validators.required]);
      this.aplicarValidators(infanciaGroup.get('demandas'), [Validators.required]);
    }
  }

  private removerValidatorsInfancia(): void {
    const infanciaGroup = this.formGroup.get('infancia');
    if (infanciaGroup) {
      this.removerValidators(infanciaGroup.get('idComarca'));
      this.removerValidators(infanciaGroup.get('indProcessoJudicial'));
      this.removerValidators(infanciaGroup.get('demandas'));
      this.removerValidators(infanciaGroup.get('nomeUnidadeAcolhimento'));
    }
  }


}
